import axios from "axios";
import { ethers } from "ethers";

export const getWallwtChainBalance = async (chain, address) => {
  try {
    const response = await axios.get(
      `https://deep-index.moralis.io/api/v2/${address}/balance?chain=${chain}`,
      {
        headers: {
          accept: "application/json",
          "X-API-Key":
            "WQDLHlQ3MtV849fuyChg8voj3UtHVByjo2QiIbagXigcsfbI0mygeB5JiMSaSffo",
        },
      }
    );

    if (!response.data) {
      return 0;
    }

    const balance = response.data.balance;
    const ethBalance = ethers.utils.formatEther(balance);
    const balanceEthShort = parseFloat(ethBalance).toFixed(4);

    return balanceEthShort;
  } catch (error) {
    console.error("Error retrieving balance:", error.message);
    return 0; // or return any other default value you want to use
  }
};

//--------------------------------TRANSACTION USING WALLET ADDRESS----------------------------------------//

export const getTansactionByWallet = async (currentChain, address) => {
  const data = axios
    .get(
      `https://deep-index.moralis.io/api/v2/${address}?chain=${currentChain}`,
      {
        headers: {
          accept: "application/json",
          "X-API-Key":
            "WQDLHlQ3MtV849fuyChg8voj3UtHVByjo2QiIbagXigcsfbI0mygeB5JiMSaSffo",
        },
      }
    )
    .then((res) => {
      let result = [];
      for (var i = 0; i < 5; i++) {
        result.push({
          date: res.data.result[i].block_timestamp,
          fromAddress: res.data.result[i].from_address,
          toAddress: res.data.result[i].to_address,
          hash: res.data.result[i].hash,
        });
      }

      // console.log("data in refffsult", result);

      return result;
    });
  return data;
};

//-------------------------------------TOKEN BALANCE USING WALLET ADDRESS------------------------------------//

export const TokenBalancebyWallet = async (chain, address, tokenAddress) => {
  // console.log("address",address)
  // console.log("chain",chain)
  // console.log("Token Address", tokenAddress)

  const data = axios
    .get(
      `https://deep-index.moralis.io/api/v2/${address}/erc20?chain=${chain}&token_addresses%5B0%5D=${tokenAddress}`,

      {
        headers: {
          accept: "application/json",
          "X-API-Key":
            "WQDLHlQ3MtV849fuyChg8voj3UtHVByjo2QiIbagXigcsfbI0mygeB5JiMSaSffo",
        },
      }
    )
    .then((res) => {
      if (!res.data) {
        return 0;
      }

      const balance = res.data[0].balance;
      // console.log("BEPPPPPPP", res.data[0].balance)

      const ethBalance = ethers.utils.formatEther(balance);

      const balanceEthShort = parseFloat(ethBalance).toFixed(4);

      //console.log("BEP BALANCE",balanceEthShort);

      return balanceEthShort;

      //console.log("balance", res.data.balance);
    })
    .catch((error) => {
      console.error("Get User Token Balance Error:", error);
      return 0;
    });

  return data;
};

//----------------------------received-transaction-by-logs-----------------------------------//

export const receivedTxByEvents = async (address, chain, contractAddress) => {
  let data = JSON.stringify({
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_escrowAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_receivedBy",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "escrowExecuted",
    type: "event",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `https://deep-index.moralis.io/api/v2/${contractAddress}/events?chain=${chain}&topic=0xab237e6dada7d940a4c66a9b66701afa91bdc019c779a5a12c24d4c00a3c90ad`,
    headers: {
      accept: "application/json",
      "X-API-Key":
        "WQDLHlQ3MtV849fuyChg8voj3UtHVByjo2QiIbagXigcsfbI0mygeB5JiMSaSffo",
      "content-type": "application/json",
    },
    data: data,
  };

  const txData = axios
    .request(config)
    .then(async (response) => {
      const length = response.data.result.length;
      let result = [];
      for (var i = 0; i < length; i++) {
        if (
          String(response.data.result[i].data._receivedBy).toLowerCase() ===
          String(address).toLowerCase()
        ) {
          result.push({
            sender: response.data.result[i].data._sender,
            receiver: response.data.result[i].data._receivedBy,
            amount: response.data.result[i].data._amount,
            date: response.data.result[i].block_timestamp,
          });
        }
      }

      return result;
    })
    .catch((error) => {
      console.log(error);
    });
  return txData;
};
